import {
	eventsHeroImage,
	eventsHeroMobileImage,
	educationImage,
	volunteerImage,
} from "../images";

export const heroData = [
	{
		imageSource: [eventsHeroImage, eventsHeroMobileImage],
		heading: "Events",
	},
];

export const eventsData = [
	{
		title: "Event1",
		imageSource: educationImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",

		linkText: "Join us",
	},
	{
		title: "Event 2",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 3",
		imageSource: educationImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 4",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 5",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 6",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 7",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 8",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 9",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 10",
		imageSource: volunteerImage,
		heading: "Event coming soon",
		description: ["Event Placeholder"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
];
